import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VendorManagmentComponent } from './vendor-managment.component';

const routes: Routes = [
  {
    path:'', component: VendorManagmentComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VendorManagmentRoutingModule { }
